export default __webpack_public_path__ + "static/media/Shroud of Eleven Forbidden Names.ae5caf61.jpg";